module.exports = __webpack_public_path__ + "img/softwaredev.4345b2f6.svg";